const AutoSmsIndivisual = () => {
	return <></>
}

export default AutoSmsIndivisual
